import React from 'react';
import { connect } from 'react-redux';
import Link from 'next/link';
import css from './ServiceProject.less';

const ServiceProject = props => {
  const upProductList = page => {
    const { institution, dispatch } = props;
    const { total } = institution;
    if (page > total) {
      return false;
    }
    dispatch({
      type: 'institution/upProductList',
      payload: { page },
    });
    return true;
  };

  const { institution } = props;
  const { productList, page, total } = institution;
  if (productList.length <= 0) {
    return false;
  }
  return (
    <div className={css.contentMain}>
      <p className={css.contentTitle}>服务项目</p>
      {productList.length >= 1 ? (
        <>
          <ul className={css.productList}>
            {productList.map(item => {
              return (
                <li className={css.productItem} key={item.id.toString()}>
                  <Link
                    href={{
                      pathname: '/tuan/[id]/',
                    }}
                    as={{
                      pathname: `/tuan/${item.id}/`,
                    }}
                    passHref
                  >
                    <div
                      className={`bg-cover ${css.productAvatar}`}
                      style={{
                        backgroundImage: `url(${item.experience_cover_url})`,
                      }}
                      key={item.id.toString()}
                    >
                      {' '}
                    </div>
                  </Link>
                  <Link
                    href={{
                      pathname: '/tuan/[id]/',
                    }}
                    as={{
                      pathname: `/tuan/${item.id}/`,
                    }}
                    passHref
                  >
                    <p className={`text-hidden-one ${css.title}`}>
                      {item.title}
                    </p>
                  </Link>
                  {/* <p className={css.scoreBox}>
                    <span className={`dinMedium ${css.total}`}>{item.score}</span>
                    <span className={css.scoreName}>最高分：硬件设施</span>
                    <span className={`dinMedium ${css.scoreNum}`}>9.0</span>
                    <span className={css.scoreLine}> </span>
                    <span className={css.scoreName}>最低分：性价比</span>
                    <span className={`dinMedium ${css.scoreNum}`}>6.2</span>
                  </p> */}
                  {item.labels.length >= 1 ? (
                    <ul className={css.labelBox}>
                      {item.labels.map((label, index) => {
                        return (
                          <li className={css.label} key={index.toString()}>
                            {label}
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}

                  <p className={`text-hidden-one ${css.msg}`}>
                    尚未收集到足够多的用户评分
                  </p>

                  <Link
                    href={{
                      pathname: '/tuan/[id]/',
                    }}
                    as={{
                      pathname: `/tuan/${item.id}/`,
                    }}
                  >
                    <a className={css.btn}>立即抢购</a>
                  </Link>
                </li>
              );
            })}
          </ul>
          {page < total ? (
            <p className={css.showMore} onClick={() => upProductList(page + 1)}>
              查看更多服务项目
            </p>
          ) : null}
        </>
      ) : (
        <p className={css.noContent}>更多精彩内容还在努力完善中</p>
      )}
    </div>
  );
};

export default connect(({ institution }) => ({
  institution,
}))(ServiceProject);
